export const ADD_ITEM = 'ADD_ITEM'
export const ADD_SELECTED_TRANSACTION = 'ADD_SELECTED_TRANSACTION'
export const REMOVE_SELECTED_TRANSACTION = 'REMOVE_SELECTED_TRANSACTION'
export const CLEAR_SELECTED_TRANSACTIONS = 'CLEAR_SELECTED_TRANSACTIONS'

// OFX Form mutations
export const SET_OFX_FORM_FIELD = 'SET_OFX_FORM_FIELD'
export const SET_OFX_FORM_PERIOD = 'SET_OFX_FORM_PERIOD'
export const SET_OFX_FORM_FILE = 'SET_OFX_FORM_FILE'
export const RESET_OFX_FORM = 'RESET_OFX_FORM'
export const INITIALIZE_OFX_FORM = 'INITIALIZE_OFX_FORM'
